import { mean, sum } from 'lodash';
import { averageSummaryMeasurements } from '.';
import {
  MeasurementSubscriptionResponse,
  OnLiveMeasurementSubscription,
  OptimizerScalarParameterTypeInternal,
  OptimizerVectorParameterTypeInternal,
  ScalarParameterTypeInternal,
  VectorParameterTypeInternal,
} from '../../../../../../data-access/gql-types/graphql';
import { SelectedPhase } from '../../../../../../types';
import { MeasurementGroupType } from '../details';

export const getMeasurementValue = (
  measurement:
    | VectorParameterTypeInternal
    | ScalarParameterTypeInternal
    | OptimizerVectorParameterTypeInternal
    | OptimizerScalarParameterTypeInternal,
  selectedPhases: number[],
  phasesValues: number[],
  summaryPhases: SelectedPhase[],
  MeasurementGroup: MeasurementGroupType,
) => {
  if (MeasurementGroup === MeasurementGroupType.Absolute) {
    return phasesValues.length ? phasesValues[0] : 0;
  }

  const selectedPhasesTemp = selectedPhases.length ? [...selectedPhases] : [];

  const phaseValuesToCount =
    selectedPhasesTemp.find((x) => x === 0) !== undefined
      ? phasesValues
      : summaryPhases.length
      ? phasesValues.filter((_, index) => selectedPhasesTemp.find((y) => y === index + 1))
      : phasesValues;

  const summaryOfPhasesValue = averageSummaryMeasurements.includes(measurement as VectorParameterTypeInternal)
    ? mean(phaseValuesToCount)
    : sum(phaseValuesToCount);

  return summaryOfPhasesValue;
};

export const getPhaseMeasurements = (
  measurementGroup: MeasurementGroupType,
  meterMeasurement: OnLiveMeasurementSubscription,
) => {
  return measurementGroup === MeasurementGroupType.SinglePhase
    ? (meterMeasurement?.onLiveMeasurement?.data as MeasurementSubscriptionResponse)?.vectorMeasurements || []
    : measurementGroup === MeasurementGroupType.Absolute
    ? (meterMeasurement?.onLiveMeasurement?.data as MeasurementSubscriptionResponse)?.scalarMeasurements || []
    : [];
};
